import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cursor-1, arrow"><path d="M3.25 3.25L9.93056 21.75L13.5278 13.5278L21.75 9.93056L3.25 3.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCursor1;
